import { Skeleton as SkeletonPrimitive } from '@/components/ui/skeleton'
import type { ReactNode } from 'react'
import { isEmpty } from '@/lib/utils'

export function Skeleton(props: { chars: number; children?: ReactNode }) {
  if (!isEmpty(props.children)) return props.children
  return <SkeletonPrimitive style={{ width: `${props.chars}ch` }}>&nbsp;</SkeletonPrimitive>
}
